import { inject } from '@angular/core';
import { FormConfig } from '../edit-create-form.interfaces';
import { GvTaTrackerAssignmentApiService } from '@shared/services';
import { TRACKER_SELECT_CONFIG } from '@shared/components/generic-select/generic-select.configs';

export const reassignGvTaTrackerFormConfig = (): FormConfig => {
    const trackerAssignmentApiService = inject(GvTaTrackerAssignmentApiService);

    return {
        fields: [
            {
                key: 'assignmentId',
                label: 'Assignment ID',
                type: 'text',
                width: 'full',
                hidden: true
            },
            {
                key: 'gvTaInfo',
                label: 'GV/TA',
                labelPosition: 'inline',
                width: 'full',
                type: 'static',
                value: (data: any) => `${data.gvTaEmployeePosition?.employee?.code || 'N/A'} - ${data.gvTaEmployeePosition?.employee?.nickname || data.gvTaEmployeePosition?.employee?.fullname || 'N/A'} (${data.gvTaEmployeePosition?.position?.name || 'N/A'})`
            },
            {
                key: 'currentTrackerInfo',
                label: 'Tracker hiện tại',
                labelPosition: 'inline',
                width: 'full',
                type: 'static',
                value: (data: any) => `${data.trackerEmployeePosition?.employee?.code || 'N/A'} - ${data.trackerEmployeePosition?.employee?.nickname || data.trackerEmployeePosition?.employee?.fullname || 'N/A'} (${data.trackerEmployeePosition?.position?.name || 'N/A'})`
            },
            {
                key: 'newTrackerEmployeePositionId',
                label: 'Tracker mới',
                required: true,
                width: 'full',
                type: 'select',
                config: { 
                    ...TRACKER_SELECT_CONFIG, 
                    service: trackerAssignmentApiService,
                    placeholder: 'Chọn tracker mới'
                },
                customErrorMessage: 'Vui lòng chọn tracker mới'
            },
            {
                key: 'fromDate',
                label: 'Ngày chuyển đổi',
                required: true,
                width: 'full',
                type: 'datepicker',
                placeholder: 'Chọn ngày chuyển đổi',
                customErrorMessage: 'Vui lòng chọn ngày chuyển đổi'
            }
        ]
    };
};

